import AxiosInstance from "../instance";
import {emptyFn, returnValidResponse} from "../utils";

const getModelInfo = async (modelName: string) => {
    const response = await AxiosInstance.getInstance().get("/get-model-info", {
        params: {
            model_name: modelName
        }
    }).catch(emptyFn);

    return returnValidResponse(response);
};

const addModelReview = async (modelName: string, score: number) => {
    const response = await AxiosInstance.getInstance().post("/review/add-review", {
        model_name: modelName,
        score
    }).catch(emptyFn);

    return response;
};

const loadCodeSamples = async (modelName: string, language: string) => {
    const response = await AxiosInstance.getInstance().get("/sample-code", {
        params: {
            model_name: modelName,
            code_language: language
        }
    });
    return returnValidResponse(response);
};

const loadModelInfo = async (modelName: string) => {
    const response = await AxiosInstance.getInstance().get("/about", {
        params: {
            model_name: modelName
        }
    });
    return returnValidResponse(response);
};

export {
    addModelReview,
    getModelInfo,
    loadCodeSamples,
    loadModelInfo
}


// WEBPACK FOOTER //
// ./src/api/models/ModelInfo.ts